/* ===========================
   Subcollections (Flickity)
   =========================== */
jQuery(document).ready(function($){
  function Subcollections(container) {
    this.$container = $(container);
    this.$slider = this.$container.find('.slider');
    this.flkty = null;
    this.listenEvent = this.checkForSlider.bind(this);
    this.init();
  }
  Subcollections.prototype = $.extend({}, Subcollections.prototype, {
    init: function() {
      this.checkForSlider();
      this.listen();
    },
    initSlider: function() {
      this.flkty = this.$slider.flickity({
        prevNextButtons: true,
        pageDots: false,
        cellAlign: "left",
        wrapAround: false,
        groupCells: true,
        contain: true,
      });
    },
    destroySlider: function() {
      if (this.flkty) {
        this.$slider.flickity("destroy");
        this.flkty = null;
      }
    },
    checkForSlider: function() {
      var windowWidth = window.innerWidth || document.documentElement.clientWidth;
      if (windowWidth >= 768) {
        if (!this.flkty) this.initSlider();
      } else {
        this.destroySlider();
      }
    },
    listen: function() {
      window.addEventListener("resize", this.listenEvent);
    },
    onUnload: function() {
      window.removeEventListener("resize", this.listenEvent);
    },
  });
});

/* ===========================
   Cart count updater
   =========================== */
function updateCountPrice(cart) {
  jQuery(".cart__count").each(function() {
    jQuery(this).toggleClass("cart__count--has-items", !!cart.item_count);
  });
  jQuery(".cart-count__number").text(cart.item_count);
}
document.addEventListener('cart:change', function(event) {
  const cart = event.detail.cart;
  updateCountPrice(cart);
});

/* ===========================
   Helpers dinero
   =========================== */
function formatearPrecio(precio) {
  return (precio / 100).toFixed(2).replace('.', ',') + ' €';
}
function formatMoney(amount, format) {
  var value = (amount / 100).toFixed(2);
  const formatWithDelimiters = (value) => {
    let parts = value.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return parts.join(",");
  };
  switch(format) {
    case "${{amount}}": return "$" + formatWithDelimiters(value);
    default: return formatWithDelimiters(value) + " €";
  }
}

/* ===========================
   Toast simple
   =========================== */
function showToast(message) {
  const toastContainer = document.getElementById('toast-container');
  if (!toastContainer) return;
  const toast = document.createElement('div');
  toast.className = 'toast show';
  toast.innerText = message;
  toastContainer.appendChild(toast);
  setTimeout(() => {
    toast.classList.remove('show');
    toast.addEventListener('transitionend', () => toastContainer.removeChild(toast));
  }, 3000);
}

/* =========================================================
   Metafields en mini-cart / drawer (pinta formato + medidas)
   ========================================================= */
document.addEventListener('DOMContentLoaded', function() {
  handleProductHandles('.line-item-url', 'product-format-');
  handleProductHandles('.line-item-url-drawer', 'product-format-drawer');
});
document.addEventListener('cart:change', function() {
  setTimeout(function() {
    handleProductHandles('.line-item-url', 'product-format-');
    handleProductHandles('.line-item-url-drawer', 'product-format-drawer');
  }, 500);
});
function handleProductHandles(selector, formatPrefix) {
  var productHandles = [];
  document.querySelectorAll(selector).forEach(function(element, index) {
    var productHandle = element.getAttribute('data-url');
    if (productHandle) {
      var match = productHandle.match(/\/products\/([a-z0-9\-]+)(\?.*)?/);
      if (match && match[0]) {
        productHandles.push({handle: match[0], index: index});
      }
    }
  });
  var formatPromises = productHandles.map((item) => getProductMetafieldsFormato(item.handle, item.index));
  Promise.all(formatPromises).then(results => {
    results.forEach(result => {
      const element = document.getElementById(formatPrefix + result.index);
      if (!element) return;
      if (result.displayTitle && result.medidas) {
        element.textContent = result.medidas + " | " + result.displayTitle;
      } else if (result.displayTitle) {
        element.textContent = result.displayTitle;
      } else if (result.medidas) {
        element.textContent = result.medidas;
      } else {
        element.textContent = "";
      }
    });
  }).catch(error => console.error('Error metafields:', error));
}
function getProductMetafieldsFormato(productHandle, index) {
  var url = productHandle + '&view=metafields-general-variants';
  return fetch(url)
    .then(response => { if(!response.ok) throw new Error('Network'); return response.json(); })
    .then(metafields => {
      var tituloVariante = metafields.tituloVariante ? metafields.tituloVariante : null;
      var formato = metafields.formato ? metafields.formato[0] : null;
      var medidas = metafields.medidas ? metafields.medidas : null;
      var displayTitle = (tituloVariante && tituloVariante !== "Default Title") ? tituloVariante : formato;
      return { displayTitle, medidas, index };
    });
}

/* ===========================
   UX móvil: ocultar tags extra
   =========================== */
function esMovil() { return /Mobi|Android/i.test(navigator.userAgent); }
document.addEventListener('DOMContentLoaded', () => {
  if (!esMovil()) return;
  document.querySelectorAll('.product-card').forEach(card => {
    const tags = card.querySelectorAll('.product__tag');
    for (let i = 1; i < tags.length; i++) tags[i].style.display = 'none';
  });
});

/* =========================================================
   Bloqueo de emojis en inputs “properties[Línea …]”
   ========================================================= */
document.addEventListener('DOMContentLoaded', () => {
  const inputs = document.querySelectorAll('input[name^="properties[Línea"]');
  const emojiRE = /\p{Extended_Pictographic}/gu;
  inputs.forEach(input => {
    input.addEventListener('input', () => {
      if (emojiRE.test(input.value)) input.value = input.value.replace(emojiRE, '');
    });
    input.addEventListener('paste', e => {
      e.preventDefault();
      const raw = (e.clipboardData || window.clipboardData).getData('text');
      const clean = raw.replace(emojiRE, '');
      if (document.queryCommandSupported?.('insertText')) {
        document.execCommand('insertText', false, clean);
      } else {
        const start = input.selectionStart, end = input.selectionEnd;
        input.setRangeText(clean, start, end, 'end');
      }
    });
  });
});

/* =========================================================
   PDP: listener de cambio de variante (no interfiere con cards)
   ========================================================= */
document.addEventListener('variant:change', function(event) {
  let variant = event.detail.variant;
  if (!variant) return;

  var newVariantPrice = variant.price;
  function updatePricesPDP() {
    jQuery('.price-with-vat').show();
    jQuery('.price-without-vat').show();
  }
  updatePricesPDP();
  jQuery('#switch-ht').off('change._pdp').on('change._pdp', updatePricesPDP);

  let priceWithVatElement = document.getElementById('price-with-vat');
  if (priceWithVatElement) {
    priceWithVatElement.innerHTML = `<b style="font-size:18px; color:black;">${formatearPrecio((newVariantPrice).toFixed(2))} </b>`;
  }
  jQuery("#formato-variante").text(variant.public_title);

  var url = window.location.href + '&view=metafields';
  fetch(url).then(r => { if(!r.ok) throw new Error('Network'); return r.json(); })
    .then(metafields => {
      jQuery(".tab-features__value-format").text(variant.public_title);
      jQuery(".tab-features__value-color-variant").text(metafields.color_variant);
      jQuery(".product__box-content").text(metafields.caja);
      jQuery(".product__sku").text(metafields.referencia);
      jQuery("#price-vat-unidad").text(metafields.precio_unidad);
      jQuery("#price-no-vat-unidad").text(metafields.precio_unidad_sin_vat);
    })
    .catch(()=>{});
});

/* =========================================================
   >>> CORE UNIFICADO: Color + Formato en product-card <<<
   ========================================================= */
(function ($) {
  const SEL = {
    card: '.product-card',
    colorSwatch: '.related-products-wrapper .color-swatch',
    formatList: '.related-products-wrapper-formato .related-product-list-formato',
    formatLink: '.related-products-wrapper-formato .related-product-list-formato a, a.formato__link', // fallback
    sizeText: '.product-grid-item__size',
    features: '.product-grid__features',
    mediaLink: '.product-card__media',
    titleLink: '.product-title',
    imgPrimary: '.product-card__image--primary',
    imgSecondary: '.product-card__image--secondary',
    salePrice: 'sale-price',
    compareAtPrice: 'compare-at-price',
    form: "form[is='product-form']",
    inputId: "input[name='id']",
    addBtn: ".cantidad-add-cart button[type='submit']",
    qtyInput: '.quantity-selector__input',
    btnDec: '.decrease-quantity',
    btnInc: '.increase-quantity',
    colorActual: '.color-actual',
  };

  // --- Utils ---
  function parseHandleFromHref(hrefOrData) {
    if (!hrefOrData) return null;
    const m = String(hrefOrData).match(/\/products\/([a-z0-9\-]+)/i);
    return m?.[1] || null;
  }
  function money(cents) {
    try { if (window.Shopify?.formatMoney) return Shopify.formatMoney(cents, Shopify.moneyFormat); }
    catch (_) {}
    const n = Number(cents || 0) / 100;
    return n.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }
  function setActive($siblings, $target) {
    $siblings.removeClass('active is-selected');
    $target.addClass('active is-selected');
  }
  function updatePrices($card, price, compare) {
    const $sale = $card.find(SEL.salePrice);
    let $cmp = $card.find(SEL.compareAtPrice);
    $sale.text(money(price));
    const showCompare = compare && Number(compare) > Number(price);
    if (showCompare) {
      if (!$cmp.length) {
        $card.find(SEL.salePrice).after('<compare-at-price class="h6 text-subdued line-through"></compare-at-price>');
        $cmp = $card.find(SEL.compareAtPrice);
      }
      $cmp.text(money(compare)).show();
      $sale.removeClass('text-subdued').addClass('text-on-sale');
    } else {
      $cmp.hide();
      $sale.removeClass('text-on-sale').addClass('text-subdued');
    }
  }
  function updateVariant($card, variant) {
    const available = !!variant?.available;
    $card.find(SEL.inputId).val(variant?.id || '');
    const $btn = $card.find(SEL.addBtn);
    const $qty = $card.find(SEL.qtyInput);
    $btn
      .prop('disabled', !available)
      .toggleClass('agotado', !available)
      .html('<span class="sr-only">Añadir a la cesta</span>' + (available ? 'Añadir' : 'Agotado'));
    $qty.prop('disabled', !available).val(available ? 1 : 0);
    $card.find(SEL.btnDec + ',' + SEL.btnInc).prop('disabled', !available);
  }
  function updateImages($card, product) {
    if (product.media?.length) {
      const p0 = product.media[0].preview_image?.src || product.media[0].src;
      if (p0) {
        const srcset = [200,300,400,500,600,700,800].map(w => `${p0}?width=${w} ${w}w`).join(', ');
        $card.find(SEL.imgPrimary).attr({ src: p0, srcset });
      }
    }
    if (product.media?.length > 1) {
      const p1 = product.media[1].preview_image?.src || product.media[1].src;
      if (p1) {
        const srcset = [200,300,400,500,600,700,800].map(w => `${p1}?width=${w} ${w}w`).join(', ');
        $card.find(SEL.imgSecondary).attr({ src: p1, srcset });
      }
    }
  }
  function updateHeader($card, product) {
    $card.find(SEL.titleLink)
      .attr('href', product.url)
      .html('<h3 style="font-weight:600;">' + product.title + '</h3>');
    $card.find(SEL.mediaLink).attr('href', product.url);
  }

  // === Deduplicación de “Pack XX uds” en el span ===
  function setFormatSpanTextOnce($span, value) {
    let label = String(value || '').replace(/\s+/g, ' ').trim();
    label = label.replace(/(Pack\s*\d+\s*uds)(\s*\1)+/ig, '$1'); // dedupe
    $span.text(label);

    // Observa cambios posteriores y corrige si otro script duplica
    let obs = $span.data('packObserver');
    if (!obs) {
      obs = new MutationObserver(() => {
        const t = $span.text().replace(/\s+/g, ' ').trim();
        const dedup = t.replace(/(Pack\s*\d+\s*uds)(\s*\1)+/ig, '$1');
        if (t !== dedup) $span.text(dedup);
      });
      try { obs.observe($span[0], { childList: true, characterData: true, subtree: true }); } catch(_) {}
      $span.data('packObserver', obs);
    }
  }
  function renderFeatures($card, medidas, label) {
    const $features = $card.find(SEL.features);
    const medidasClean = String(medidas || '').replace(/\s*\|\s*Pack[^|]+$/i, '').trim();
    const prefix = medidasClean ? `${medidasClean} |&nbsp;` : '';
    if ($features.length) {
      // Reescribimos TODO el bloque para garantizar un único span
      $features.html(`${prefix}<span id="format-size" class="product-grid-item__size"></span>`);
      setFormatSpanTextOnce($features.find('#format-size'), label);
    } else {
      // Fallback si no existe el bloque features
      const $size = $card.find(SEL.sizeText);
      if ($size.length) setFormatSpanTextOnce($size, label);
    }
  }

  // Construye la lista de formatos y deja el pack activo + features
  function buildFormatsFromMeta($card, meta, currentHandle) {
    if (!meta?.Formatos?.length) return false;

    const html = meta.Formatos.map(f => `
      <a data-handle="${f.handle}" href="/products/${f.handle}"
         class="formato-swatch size__link" style="width:auto; margin-right:5px; line-height:14px;">
        ${f.metafields?.magento_formato || f.title || 'Formato'}
      </a>
    `).join('');
    $card.find(SEL.formatList).html(html);

    const $links = $card.find(SEL.formatLink);
    let $match = $links.filter(function () {
      return parseHandleFromHref(jQuery(this).attr('href')) === currentHandle;
    }).first();
    if (!$match.length) $match = $links.first();
    setActive($links, $match);

    // Label del pack (limpio por si viniera repetido)
    let label = ($match.text() || '').replace(/\s+/g,' ').trim();
    label = label.replace(/(Pack\s*\d+\s*uds)(\s*\1)+/ig, '$1');

    const medidas = Array.isArray(meta.medidas) ? meta.medidas[0] : meta.medidas;
    renderFeatures($card, medidas, label);

    return true;
  }

  async function loadProduct($card, handle) {
    const [product, meta] = await Promise.all([
      $.getJSON('/products/' + handle + '.js'),
      fetch('/products/' + handle + '?view=metafields-general').then(r => r.ok ? r.json() : null).catch(() => null),
    ]);

    updateHeader($card, product);
    updateImages($card, product);

    const v0 = product.variants?.[0] || null;
    updatePrices($card, product.price ?? v0?.price ?? 0, product.compare_at_price ?? v0?.compare_at_price ?? 0);
    updateVariant($card, v0);

    // Formatos del mismo color
    const built = buildFormatsFromMeta($card, meta, product.handle);
    if (!built) {
      const $links = $card.find(SEL.formatLink);
      if ($links.length) {
        let $match = $links.filter(function () {
          return parseHandleFromHref(jQuery(this).attr('href')) === product.handle;
        }).first();
        if (!$match.length) $match = $links.first();
        setActive($links, $match);
        const medidasText = ($card.find(SEL.features).text() || '').split('|')[0].trim();
        renderFeatures($card, medidasText, $match.text().trim());
      }
    }
    return product;
  }

  // Click FORMATO (variante local vs. producto hermano con otro handle)
$(document).on('click', SEL.formatLink, async function (e) {
  e.preventDefault();
  const $a = $(this);
  const $card = $a.closest(SEL.card);

  // ¿Es variante del MISMO producto? (usa data-* o ?variant=)
  const variantIdFromData = $a.data('variant-id');
  const variantIdFromHref = (($a.attr('href') || '').match(/[?&]variant=(\d+)/) || [])[1];
  const isSameProductVariant = !!(variantIdFromData || variantIdFromHref);

  if (isSameProductVariant) {
    // --- VARIANTE LOCAL: actualizamos en caliente sin fetch ---
    setActive($card.find(SEL.formatLink), $a);

    const vId = String(variantIdFromData || variantIdFromHref);
    const vPrice = Number($a.data('variant-price') || 0);
    const vCompare = Number($a.data('variant-compare-price') || 0);
    const vAvail = String($a.data('variant-available')) === 'true';

    // Precio + compare
    updatePrices($card, vPrice, vCompare);

    // Formulario / botón / qty
    updateVariant($card, { id: vId, available: vAvail });

    // Texto del formato (evitamos duplicados "Pack XX uds")
    const labelRaw = ($a.text() || '').trim();
    const label = labelRaw.replace(/(Pack\s*\d+\s*uds)(\s*\1)+/ig, '$1');

    // Pintar en features -> <span class="product-grid-item__size">
    const $features = $card.find(SEL.features);
    const $size = $features.find('.product-grid-item__size');
    if ($size.length) {
      // usa el dedupe con observer
      setFormatSpanTextOnce($size, label);
    } else {
      $card.find(SEL.sizeText).text(label);
    }

    return; // ¡listo!
  }

  // --- FORMATO CON OTRO HANDLE: seguimos con el flujo de carga ---
  const handle = parseHandleFromHref($a.attr('href')) || $a.data('handle');
  if (!handle) return;

  setActive($card.find(SEL.formatLink), $a);
  try { await loadProduct($card, handle); } catch (_) {}
});


  // Click COLOR
  $(document).on('click', SEL.colorSwatch, async function (e) {
    e.preventDefault();
    const $sw = $(this);
    const $card = $sw.closest(SEL.card);
    if ($sw.hasClass('active') || $sw.hasClass('is-selected')) return;

    let handle = parseHandleFromHref($sw.data('variant-url') || $sw.attr('href'));
    if (!handle) return;

    try {
      await loadProduct($card, handle);
      setActive($card.find(SEL.colorSwatch), $sw);
      const colorName = $sw.find('.sr-only').text();
      if (colorName) $card.find(SEL.colorActual).text(colorName);
    } catch (_) {}
  });

  // Estado inicial (marca el formato del handle de la card y normaliza features)
  $(function () {
    $(SEL.card).each(function () {
      const $card = $(this);
      const initialHandle = $card.attr('data-handle') || $card.attr('handle');
      if (!initialHandle) return;

      const $links = $card.find(SEL.formatLink);
      if ($links.length) {
        let $match = $links.filter(function () {
          return parseHandleFromHref($(this).attr('href')) === initialHandle;
        }).first();
        if (!$match.length) $match = $links.first();
        setActive($links, $match);

        const featuresText = ($card.find(SEL.features).text() || '').trim();
        const medidasDom = featuresText.split('|')[0].replace(/\s*\|\s*Pack[^|]+$/i,'').trim();
        renderFeatures($card, medidasDom, $match.text().trim());
      }
    });
  });

})(jQuery);


$(document).ready(function() {
  // Usamos el selector de jQuery y el método .on() que es más moderno y flexible.
  $('.js-link').on('click', function(event) {
    
    // Buena práctica: previene cualquier comportamiento por defecto que pudiera tener el elemento.
    event.preventDefault(); 
    
    // Obtenemos el data-href usando el método de jQuery .data()
    var enlace = $(this).data('href');
    
    // Una última comprobación para asegurarnos de que el enlace no está vacío
    if (enlace && enlace.length > 0) {
      window.location.href = enlace;
    } else {
      console.log('Se hizo clic en un js-link, pero no tiene un data-href válido.');
    }
  });
});


jQuery(document).ready(function($) {
  // Retrasamos un poco por si el tema registra listeners después del DOM ready
  setTimeout(function() {
    $('.product-card').each(function() {
      var $card = $(this);

      // Primer botón B2B del card
      var $firstFormat = $card.find('.format-selection-b2b').first();

      if ($firstFormat.length) {
        // Si ya hay un formato activo en este card, no hacemos nada
        var hasActive = $card.find('.format-selection-b2b.active').length > 0;

        if (!hasActive) {
          // Evita FOUC: ocultamos todos los spark antes del click
          $card.find('.spark-product-card-b2b').hide();

          // Dispara el click para reutilizar tu lógica existente
          $firstFormat.trigger('click');
        }
      }
    });
  }, 50);
});


document.addEventListener("DOMContentLoaded", function() {
  const links = document.querySelectorAll('a[style*="color: #6CAB3D"]');

  links.forEach(link => {
    // Marca secuencias de palabras mayúsculas, incluyendo palabras de 1 letra si van junto a otras
    const regex = /\b([A-ZÁÉÍÓÚÜÑ0-9]+(?:\s+[A-ZÁÉÍÓÚÜÑ0-9]+)*)\b/g;

    link.innerHTML = link.textContent.replace(regex, function(match) {
      // Solo aplica si TODA la secuencia está en mayúsculas (ignorando espacios y números)
      return match === match.toUpperCase() ? `<strong>${match}</strong>` : match;
    });
  });
});